import { withKeycloak } from "@react-keycloak/web";
import { withRouter } from "react-router-dom";
import { labels } from "../../../../../localization/labels";
import TagService from "../../../../../services/TagService";
import CommonUtil from "../../../../../utils/CommonUtil";
import OccurrencesContainer from "../Occurrences/OccurrencesContainer";

class TopTagsContainer extends OccurrencesContainer {
  constructor(props) {
    super(props);
    this.tagService = new TagService(this.keycloak);

    this.viewType = "tagcloud";
  }

  loadOccurrences = () => {
    const pageInfo = { size: 25 };
    this.prepareCall(
      this.tagService.getTagOccurrence(
        pageInfo,
        this.onOccurrencesLoaded,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  occurrenceMapper = element => ({
    text: CommonUtil.trimLongWord(element.name, 30, "..."),
    value: element.occurrence,
    fullText: element.name
  });

  getComponentTitle = () => {
    return labels.mostPopularTags;
  };
}
export default withKeycloak(withRouter(TopTagsContainer));
